import { useAtom } from 'jotai'
import { useCallback, useMemo, useRef } from 'react'

import { jobAtom } from '../store/gigiChat/Export'

const useTrackExportJob = (poolId: number) => {
    const [jobs, setJobs] = useAtom(jobAtom)

    const setJobsRef = useRef(setJobs)
    const poolIdRef = useRef(poolId)

    setJobsRef.current = setJobs
    poolIdRef.current = poolId

    const addJob = useCallback((job: Promise<unknown>) => {
        const boundPoolId = poolIdRef.current

        setJobsRef.current((j) => {
            const newJobs = new Map(j)
            const count = (j.get(boundPoolId) ?? 0) + 1

            if (count === 0) {
                newJobs.delete(boundPoolId)
            } else {
                newJobs.set(boundPoolId, count)
            }

            return newJobs
        })

        void job.finally(() => {
            setJobsRef.current((j) => {
                const newJobs = new Map(j)
                const count = (j.get(boundPoolId) ?? 0) - 1

                if (count === 0) {
                    newJobs.delete(boundPoolId)
                } else {
                    newJobs.set(boundPoolId, count)
                }

                return newJobs
            })
        })
    }, [])

    const busy = useMemo(() => {
        return (jobs.get(poolId) ?? 0) > 0
    }, [jobs, poolId])

    return useMemo(() => ({ busy, addJob }), [busy, addJob])
}

export default useTrackExportJob
